import { NavigateOptions, To } from 'react-router-dom';

export const routerHelper = (to: string, currentSearch: string) => {
    const currentSearchParams = new URLSearchParams(currentSearch);
    const mergeQueryParams = (): string => {
        currentSearchParams.forEach((value, key) => {
            currentSearchParams.set(key, value);
        });

        const containsCurrentSearch = to.includes(currentSearchParams.toString());

        return containsCurrentSearch ? to : `${to}?${currentSearchParams.toString()}`;
    };

    return {
        mergeQueryParams,
        isPersistNeeded: Boolean(currentSearchParams.get('__dev')),
    };
};

export const overriddenNavigate =
    (originalNavigate: { (to: number): Promise<void>; (to: To | null, options?: NavigateOptions): Promise<void> }) =>
    async (to: number | To | null, options?: NavigateOptions): Promise<void> => {
        if (to === null) {
            // Handle the case when 'to' is null; just call the original navigate
            return originalNavigate(to, options);
        } else if (typeof to === 'number') {
            // Handle navigating by history steps (e.g., back or forward)
            return originalNavigate(to);
        } else {
            // On reload TO is an object {pathname, search, hash}
            const toStr = typeof to === 'object' ? (to as any).pathname : to;

            // Normal URL-based navigation with query parameter merging
            const { mergeQueryParams, isPersistNeeded } = routerHelper(toStr, window.location.search);

            const destination = isPersistNeeded ? mergeQueryParams() : toStr;

            return originalNavigate(destination, options);
        }
    };
